import { CrmSurveyEntity, PaginatedEntity, Pagination } from '@core/entities';
import { UseCRMSurvey } from '@core/usecases';
import { SurveyPollType } from '@core/enums';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
export class CrmSurveysComposition {
  surveys: CrmSurveyEntity[];
  currentSurvey: CrmSurveyEntity;
  pagination: Pagination = new PaginatedEntity().pagination;
  isLoading = true;

  private readonly _useCRMSurvey = new UseCRMSurvey();
  private _currentRoute: string;

  onPaginationChange(pagination: Pagination) {
    this.pagination = pagination;
    this.isLoading = true;
    switch (this._currentRoute) {
      case SurveyPollType.ACTIVE_POLLS:
        this._fetchActiveSurveys();
        break;
      case SurveyPollType.MY_POLLS:
        this._fetchMySurveys();
        break;
      case SurveyPollType.COMPLETED_POLLS:
        this._fetchCompletedSurveys();
        break;
      default:
        break;
    }
  }

  protected _fetchActiveSurveys() {
    this._currentRoute = SurveyPollType.ACTIVE_POLLS;
    this._useCRMSurvey
      .getActiveSurveys(this.pagination)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (response) => {
          this.surveys = response.surveys;
          this.pagination = response.pagination;
          this.isLoading = false;
        },
      });
  }

  protected _fetchMySurveys() {
    this._currentRoute = SurveyPollType.MY_POLLS;
    this._useCRMSurvey
      .getMySurveys(this.pagination)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (response) => {
          this.surveys = response.surveys;
          this.pagination = response.pagination;
          this.isLoading = false;
        },
      });
  }

  protected _fetchCompletedSurveys() {
    this._currentRoute = SurveyPollType.COMPLETED_POLLS;
    this._useCRMSurvey
      .getCompletedSurveys(this.pagination)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (response) => {
          this.surveys = response.surveys;
          this.pagination = response.pagination;
          this.isLoading = false;
        },
      });
  }

  protected _fetchSurveyDetails(surveyId: number) {
    this._useCRMSurvey
      .getSurveyDetails(surveyId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (response) => {
          this.currentSurvey = response;
          this.isLoading = false;
        },
      });
  }
}
